import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left-light--sprite",
  "use": "arrow-left-light--sprite-usage",
  "viewBox": "0 0 9 14",
  "content": "<symbol viewBox=\"0 0 9 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left-light--sprite\">\n    <path d=\"M8 13L2 7L8 1\" stroke=\"#3D3D3D\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol